import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=4438512f&scoped=true&lang=pug&"
import script from "./Customer.vue?vue&type=script&lang=coffee&"
export * from "./Customer.vue?vue&type=script&lang=coffee&"
import style0 from "./Customer.vue?vue&type=style&index=0&id=4438512f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4438512f",
  null
  
)

export default component.exports